import {Component, OnInit, ViewEncapsulation, ElementRef} from '@angular/core';
import {AdmissionService} from './admission.service';
import {Router} from '@angular/router';
import {LoginService} from '../login/login.service';
import {GroupService} from '../groups/groups.service';
import {TransportService} from '../transport/transport.service';
import {FormValidator} from '../form.validator';


declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;

interface AcademicYearObj {
  pkAcademicId: number;
  Year: string;
}

interface CategoryObj {
  categoryId: number;
  categoryName: string;
}

interface ClassSectionObj {
  classId: number;
  className: string;
  classDivision: string;
}

@Component({
  selector: 'app-admission',
  templateUrl: './admission.component.html',
  styleUrls: [
    './admission.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [AdmissionService, GroupService, LoginService, TransportService, FormValidator]
})
export class AdmissionComponent implements OnInit {

  currentSchoolId = '';
  selectedAcademicYearObj = null;
  academicYearsList: [AcademicYearObj];
  selectedCategory = null;
  categoryList: [CategoryObj];
  classSectionList: [ClassSectionObj];
  selectedClassSection = null;
  selectedClassSectionId = null;
  selectedBusRoute = null;
  selectedBusStop = null;
  academicId = 0;
  schoolAcademicCurrentYear = '';
  feesComponentsList = [];
  addAmountStatus = true;
  applyAmountStatus = false;
  mTotalFees = 'Rs. 0';
  mTotalBusFees = 'Rs. 0';
  feesAmount = 0;
  mFeesComponentName = '';
  mFeesComponentDue = '';
  mFeesComponentAmount = '0';
  busRouteList = [];
  busStopList = [];
  admissionStudentImage = 'assets/img/avatar-students.png';
  mStudentName = '';
  mSurName;
  mCast;
  mGenderGroup = '';
  mDOB;
  mBloodGroup = 'A+';
  mReligion = '';
  mNationality = '';
  mStudentEmail;
  mStudenNumber;
  mFatherName;
  mFatherNumber;
  mFatherOccupation;
  mFatherQualification;
  mFatherEmail;
  mFatherAddress;
  mMotherName;
  mMotherNumber;
  mMotherOccupation;
  mMotherQualification;
  mMotherSameFatherAddress;
  mMotherAddress;
  mGuardianName;
  mGuardianNumber;
  mGuardianOccupation;
  mGuardianQualification;
  mGuardianSameFatherAddress;
  mGuardianAddress;
  mAdmissionBase;
  mAdmissionStream = '';
  mAdmissionNumber;
  mAdmissionDate;
  mMotherEmail;
  mGuardianEmail;
  mBusId;


  tab1activestatus = true;
  tab2activestatus;
  tab3activestatus;
  tab4activestatus;
  tab5activestatus;

  tab1donestatus;
  tab2donestatus;
  tab3donestatus;
  tab4donestatus;
  tab5donestatus;

  selectedAcademicYear = '';
  admissionBase = '';

  nextTabStatus1 = false;
  nextTabStatus2 = false;
  classSections = null;

  isNameRequiredError: boolean = false;
  isMaxLengthError: boolean = false;
  isNoNumberStartError: boolean = false;

  constructor(private admissionservice: AdmissionService, private groupservice: GroupService,
              private router: Router, private loginservice: LoginService, private elRef: ElementRef,
              private transportservice: TransportService, private  formValidator: FormValidator) {
    this.mTotalFees = 'Rs. 0';
  }

  validateName() {
    
    // Reset error flags
    this.isNameRequiredError = false;
    this.isMaxLengthError = false;
    this.isNoNumberStartError = false;

    // Perform validations
    if (!this.mStudentName) {
      this.isNameRequiredError = true;
    } else if (this.mStudentName.length > 100) {
      this.isMaxLengthError = true;
    } else if (/^\d/.test(this.mStudentName)) {
      this.isNoNumberStartError = true;
    }
  }

  // tab 1 validate
  validateTab1() {
    this.mDOB = $('#admission-dob').val();
    this.mAdmissionDate = $('#admission-date').val();

    // customToastr('Updated','success');
    if (!this.formValidator.validateIsData(this.mStudentName)) {
      customToastr('Invalid student name!', 'error');
    } else if (!this.formValidator.validateIsData(this.mGenderGroup)) {
      customToastr('Invalid student gender!', 'error');
    } else if (!this.formValidator.validateIsData(this.mDOB)) {
      customToastr('Select student DOB!', 'error');
    } else if (!this.formValidator.validateIsData(this.mBloodGroup)) {
      customToastr('Blood group is not valid!', 'error');
    } else if (!this.formValidator.validateIsData(this.mNationality)) {
      customToastr('Select student nationality!', 'error');
    } else if (!this.formValidator.validateIsData(this.selectedAcademicYear)) {
      customToastr('Invalid academic year!', 'error');
    } else if (!this.formValidator.validateIsData(this.admissionBase)) {
      customToastr('Select admission base!', 'error');
    } else if (!this.formValidator.validateIsData(this.mAdmissionStream)) {
      customToastr('Select admission stream!', 'error');
    } else if (this.selectedCategory === null) {
      customToastr('Invalid class category!', 'error');
    } else if (this.selectedClassSectionId === null) {
      customToastr('Invalid class!', 'error');
    } else if (!this.formValidator.validateIsData(this.mAdmissionDate)) {
      customToastr('Selet admission date!', 'error');
    } else {
      // customToastr('go----!','success');
      this.nextTabStatus1 = true;
    }
  }


  // tab 2 validate
  validateTab2() {
    if (this.mFatherName === undefined || !this.formValidator.validateIsData(this.mFatherName)) {
      customToastr('Father name is missing!', 'error');
    } else if (this.mFatherNumber === undefined || !this.formValidator.validateIsData(this.mFatherNumber)) {
      customToastr('Enter father contact number!', 'error');
    } else if (this.mFatherAddress === undefined || !this.formValidator.validateIsData(this.mFatherAddress)) {
      customToastr('Father address is missing!', 'error');
    } else if (this.mMotherName === undefined || !this.formValidator.validateIsData(this.mMotherName)) {
      customToastr('Mother name is missing!', 'error');
    } else if (this.mMotherNumber === undefined || !this.formValidator.validateIsData(this.mMotherNumber)) {
      customToastr('Enter mother contact number!', 'error');
    } else if (this.mMotherSameFatherAddress !== true && this.mMotherAddress === undefined ||
      !this.formValidator.validateIsData(this.mMotherAddress)) {
      customToastr('Mother address is missing!', 'error');
    } else {
      // customToastr('go----!','success');
      this.nextTabStatus2 = true;
    }
  }

  // next tab function
  nexttab(getTab) {

    this.nextTabStatus1 = false;
    this.nextTabStatus2 = false;
    if (getTab === 'tab1') {
      this.tab1activestatus = true;
      this.tab2activestatus = false;
      this.tab3activestatus = false;
      this.tab4activestatus = false;
      this.tab5activestatus = false;
      this.tab1donestatus = false;
      this.tab2donestatus = false;
      this.tab3donestatus = false;
      this.tab4donestatus = false;
      this.tab5donestatus = false;
    } else if (getTab === 'tab2') {
      this.tab1activestatus = false;
      this.tab2activestatus = true;
      this.tab3activestatus = false;
      this.tab4activestatus = false;
      this.tab5activestatus = false;
      this.tab1donestatus = true;
      this.tab2donestatus = false;
      this.tab3donestatus = false;
      this.tab4donestatus = false;
      this.tab5donestatus = false;
    } else if (getTab === 'tab3') {
      this.tab1activestatus = false;
      this.tab2activestatus = false;
      this.tab3activestatus = true;
      this.tab4activestatus = false;
      this.tab5activestatus = false;
      this.tab1donestatus = true;
      this.tab2donestatus = true;
      this.tab3donestatus = false;
      this.tab4donestatus = false;
      this.tab5donestatus = false;
    } else if (getTab === 'tab4') {
      this.tab1activestatus = false;
      this.tab2activestatus = false;
      this.tab3activestatus = false;
      this.tab4activestatus = true;
      this.tab5activestatus = false;
      this.tab1donestatus = true;
      this.tab2donestatus = true;
      this.tab3donestatus = true;
      this.tab4donestatus = false;
      this.tab5donestatus = false;
    } else if (getTab === 'tab5') {
      this.tab1activestatus = false;
      this.tab2activestatus = false;
      this.tab3activestatus = false;
      this.tab4activestatus = false;
      this.tab5activestatus = true;
      this.tab1donestatus = true;
      this.tab2donestatus = true;
      this.tab3donestatus = true;
      this.tab4donestatus = true;
      this.tab5donestatus = false;
    }
  }


  // prev tab function
  prevtab(getTab) {
    if (getTab === 'tab1') {
      this.tab1activestatus = true;
      this.tab2activestatus = false;
      this.tab3activestatus = false;
      this.tab4activestatus = false;
      this.tab5activestatus = false;
      this.tab1donestatus = false;
      this.tab2donestatus = false;
      this.tab3donestatus = false;
      this.tab4donestatus = false;
      this.tab5donestatus = false;
    } else if (getTab === 'tab2') {
      this.tab1activestatus = false;
      this.tab2activestatus = true;
      this.tab3activestatus = false;
      this.tab4activestatus = false;
      this.tab5activestatus = false;
      this.tab1donestatus = true;
      this.tab2donestatus = false;
      this.tab3donestatus = false;
      this.tab4donestatus = false;
      this.tab5donestatus = false;
    } else if (getTab === 'tab3') {
      this.tab1activestatus = false;
      this.tab2activestatus = false;
      this.tab3activestatus = true;
      this.tab4activestatus = false;
      this.tab5activestatus = false;
      this.tab1donestatus = true;
      this.tab2donestatus = true;
      this.tab3donestatus = false;
      this.tab4donestatus = false;
      this.tab5donestatus = false;
    } else if (getTab === 'tab4') {
      this.tab1activestatus = false;
      this.tab2activestatus = false;
      this.tab3activestatus = false;
      this.tab4activestatus = true;
      this.tab5activestatus = false;
      this.tab1donestatus = true;
      this.tab2donestatus = true;
      this.tab3donestatus = true;
      this.tab4donestatus = false;
      this.tab5donestatus = false;
    } else if (getTab === 'tab5') {
      this.tab1activestatus = false;
      this.tab2activestatus = false;
      this.tab3activestatus = false;
      this.tab4activestatus = false;
      this.tab5activestatus = true;
      this.tab1donestatus = true;
      this.tab2donestatus = true;
      this.tab3donestatus = true;
      this.tab4donestatus = true;
      this.tab5donestatus = false;
    }

  }


  finishAdmissionProcess() {
    customToastr('Admission Success!', 'success');
  }


  initScript() {

    $('.after').empty();
    $('#device-breakpoints').remove();
    $('.after').append('<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();' +
      'toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;' +
      'toastr.options.positionClass = \'toast-top-right\';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;' +
      'toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = \'swing\';' +
      'toastr.options.hideEasing = \'swing\';toastr.options.showMethod = \'slideDown\';toastr.options.hideMethod = \'slideUp\';' +
      'toastr[type](message, \'\');return 0;} </' + 'script>');
  }

  isValidToken() {
    let isValidToken = false;
    let isValidSchool = 0;
    this.loginservice.isValidToken(localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          isValidToken = data.isValid;
          if (isValidToken === true) {
            this.loginservice.isValidSchoolId(localStorage.getItem('schoolinfo'))
              .subscribe(
                (validData: any) => {
                  isValidSchool = validData.schoolExist;
                  this.currentSchoolId = localStorage.getItem('schoolinfo');
                  if (isValidSchool !== 1) {
                    this.router.navigate(['/login']);
                  } else {
                    this.initScript();
                    this.getAllAcademicYears();
                    this.getAllCategories();
                    this.getCurrentAcademic(this.currentSchoolId);
                    this.getAllBusRoutes(this.currentSchoolId);
                  }
                },
                error => {
                  }
              );
          } else {
            this.router.navigate(['/login']);
          }
        },
        error => {

          }
      );
  }

  ngOnInit() {
    this.isValidToken();
  }

  elementClick() {
    // this.elRef.nativeElement.querySelector('#add-amount').addEventListener('click', (event) => this.handleEvent(event));
  }

  getCurrentAcademic(schoolId) {
    this.groupservice.groupsStudentAcademicList(schoolId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          for (const item of data.academicList) {
            if (item.InActive === 0) {
              this.academicId = item.pkAcademicId;
              this.schoolAcademicCurrentYear = item.Year;
            }
          }
        },
        error => {
          }
      );
  }

  getAllBusRoutes(schoolId) {
    this.transportservice.getAllBuses(schoolId,this.selectedAcademicYear, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.busRouteList = data;
        },
        error => {
          }
      );
  }

  getStopsOfRoute(schoolId, classId) {
    this.transportservice.getstopsOfRoute(schoolId, classId,this.selectedAcademicYear, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.busStopList = data;
        },
        error => {
          }
      );
  }

  getAllAcademicYears() {
    this.admissionservice.getAllAcademicYears(this.currentSchoolId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data !== null && data !== undefined && data.length > 0) {
            this.academicYearsList = data;
            this.selectedAcademicYearObj = data[0];
          }
        },
        error => {
          }
      );
  }

  getAllCategories() {
    this.admissionservice.getAllCategories(this.currentSchoolId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.categoryList = data;
        },
        error => () => {

        }
      );
  }

  fetchCategoryDetails(categoryId) {
    this.admissionservice.getCategoryDetailsFromCategoryId(this.currentSchoolId, categoryId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data !== undefined && data !== null && data.className !== undefined && data.className.length > 0) {

            this.classSectionList = data.className;
          }
        },
        error => () => {

        }
      );
  }

  fetchClassSectionOnClassId(classId) {
    this.admissionservice.getClassDetailsFromClassId(classId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data !== undefined && data !== null && data.length > 0) {
            this.classSections = data;
          }

        },
        error => {

        }
      );
  }


  fetchFeeComponentOfClass(classId) {
    this.feesComponentsList = [];
    this.admissionservice.getFeeComponentsOfClass(this.currentSchoolId, this.academicId, classId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data !== null && data !== undefined && data.length > 0) {
            this.feesComponentsList = data;
            this.calculateTotalFees();
          }

        },
        error => {
        }
      );
  }

  showAddAmount(feesTypeId, position) {
    $('.showaddamount_' + feesTypeId).hide();
    $('.showapplyamount_' + feesTypeId).show();
  }

  applyAmount(feesTypeId, position) {
    $('.showaddamount_' + feesTypeId).show();
    $('.showapplyamount_' + feesTypeId).hide();
    let amount = $('.feesamount_' + feesTypeId).val();
    if (amount !== null && amount !== undefined && amount !== '') {
      try {
        amount = parseInt(amount, 10);
        const feesData = this.feesComponentsList;
        feesData[position].Amount = amount;
        this.feesComponentsList = feesData;
        this.calculateTotalFees();
        this.applyFeesAmountForTerm(feesTypeId, amount, position);
      } catch (err) {
      }
    }
  }

  applyFeesAmountForTerm(feesTypeId, amount, position) {
    this.admissionservice.applyFeesAmountForTerm(this.currentSchoolId, this.academicId, this.selectedClassSection,
      feesTypeId, amount, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data !== undefined && data !== null && data.status !== undefined) {
            if (data.status === false) {
              delete this.feesComponentsList[position].Amount;
            } else {
            }
          } else {
            delete this.feesComponentsList[position].Amount;
          }
          this.calculateTotalFees();
        },
        error => {
          delete this.feesComponentsList[position].Amount;
          this.calculateTotalFees();
        }
      );
  }

  addFeesComponent() {
    const selectedAssignee = $('#fees-comp-assigned').find(':selected').text();
    this.mFeesComponentDue = $('#fees-comp-due').val();
    const feesObj = {
      Name: this.mFeesComponentName,
      includeInTerm: 0,
      academicId: this.academicId,
      AppliesTo: selectedAssignee,
      duedate: this.mFeesComponentDue,
      amount: this.mFeesComponentAmount,
      classId: this.selectedClassSection,
      schoolId: this.currentSchoolId
    };
    const updateInfo = {
      Name: feesObj.Name,
      Amount: this.mFeesComponentAmount,
      pkFeesTypeId: -100
    };
    this.feesComponentsList.push(updateInfo);

    this.admissionservice.createFeesComponent(feesObj, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          if (data.status !== undefined && data.status === true) {
            this.feesComponentsList[this.feesComponentsList.length - 1].pkFeesTypeId = data.data.pkFeesTypeId;
          }

        },
        error => {
        }
      );
    $('#newcomponent .close').click();

  }

  calculateTotalFees() {
    this.feesAmount = 0;
    for (const item of this.feesComponentsList) {
      if (item.Amount !== undefined) {
        this.feesAmount += item.Amount;
      }
    }
    this.mTotalFees = 'Rs. ' + this.feesAmount;
  }

  iterateFareOfBus(stopNumber) {
    for (const item of this.busStopList) {
      if (item.StopNumber === stopNumber) {
        this.mTotalBusFees = 'Rs ' + item.fare;
        break;
      }
    }
  }

  iterateBusId(routeId) {
    for (const item of this.busRouteList) {
      if (item.pkRouteId === routeId) {
        this.mBusId = item.pkBusId;
        break;
      }
    }
  }

  finishedAdmission() {
    this.mMotherOccupation = $('#admission-mother-occupation').find(':selected').text();
    this.mAdmissionBase = $('#admission-base').find(':selected').text();
    this.mAdmissionStream = $('#admission-stream').find(':selected').text();
    this.mDOB = $('#admission-dob').val();
    this.mAdmissionDate = $('#admission-date').val();
    this.mGuardianOccupation = $('#admission-guardian-occupation').find(':selected').text();
    this.mFatherOccupation = $('#admission-father-occupation').val();
    this.mBloodGroup = $('#admission-blood-group').find(':selected').text();
    this.mReligion = $('#admission-religion').find(':selected').text();

    const admissionObj = {
      schoolId: this.currentSchoolId,
      registrationId: this.mAdmissionNumber,
      studentName: this.mStudentName,
      classId: this.selectedClassSectionId,
      parentName: this.mFatherName,
      studentEmail: this.mStudentEmail,
      emailID: this.mFatherEmail,
      dateOfBirth: this.mDOB,
      mobileNumber: this.mFatherNumber,
      dateOfAdmission: this.mAdmissionDate,
      address: this.mFatherAddress,
      fkAcademicId: this.selectedAcademicYearObj,
      academicId: this.selectedAcademicYearObj,
      surname: this.mSurName,
      bloodGroup: this.mBloodGroup,
      religion: this.mReligion,
      cast: this.mCast,
      nationality: this.mNationality,
      studentPhone: this.mStudenNumber,
      fatherOccupation: this.mFatherOccupation,
      fatherQualification: this.mFatherQualification,
      fatherEmail: this.mFatherEmail,
      motherName: this.mMotherName,
      motherPhone: this.mMotherNumber,
      motherOccupation: this.mMotherOccupation,
      motherQualification: this.mMotherQualification,
      motherEmail: this.mMotherEmail,
      motherAddress: this.mMotherAddress,
      guardianName: this.mGuardianName,
      guardianPhone: this.mGuardianNumber,
      guardianOccupation: this.mGuardianOccupation,
      guardianQualification: this.mGuardianQualification,
      guardianEmail: this.mGuardianEmail,
      gender: this.mGenderGroup,
      admissionBase: this.mAdmissionBase,
      admissionStream: this.mAdmissionStream,
      studentImage: '/image/placeholder.png',
      stopId: this.selectedBusStop,
      busId: this.mBusId
    };
    const imageData = $('.cropme-admission img').attr('src');
    admissionObj.studentImage = imageData;

    // TODO: Show progress

    if (imageData !== this.admissionStudentImage) {
      this.uploadNewAdmissionImage(imageData, function(imageName) {
        admissionObj.studentImage = imageName;
        this.callNewAdmissionService(admissionObj);
      });
    } else {
      this.callNewAdmissionService(admissionObj);
    }

  }

  callNewAdmissionService(admissionObj) {
    this.admissionservice.createNewAdmission(admissionObj, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {          
          // callback(data);
          // TODO: Check Status & show status message
          if (data.status === true) {
            customToastr('New admission success!!!', 'success');
          }
        },
        error => {
          // callback(false)
          // TODO: Show error message
        }
      );
  }

  uploadNewAdmissionImage(imageData, callback) {
    this.admissionservice.uploadImage(imageData, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          callback(data);
        },
        error => {
          callback(false);
        }
      );
  }

  updateSelectedAcademic(academicId: string): void {
    this.selectedAcademicYearObj = academicId;
  }

  updateSelectedCategory(categoryId: string): void {

    this.classSectionList = null;
    this.classSections = null;

    this.selectedCategory = categoryId;
    this.fetchCategoryDetails(this.selectedCategory);
  }

  updateSelectedClassSection(classId: string): void {
    this.selectedClassSection = classId;
    this.fetchClassSectionOnClassId(classId);

    this.fetchFeeComponentOfClass(this.selectedClassSection);
  }

  updateSelectedClassSectionId(classId: string): void {
    this.selectedClassSectionId = classId;
  }

  updateSelectedBusRoute(routeId: string): void {
    this.selectedBusRoute = routeId;
    this.iterateBusId(routeId);
    this.getStopsOfRoute(this.currentSchoolId, this.selectedBusRoute);
  }

  updateSelectedBusStop(stopNumber: string): void {
    this.selectedBusStop = stopNumber;
    this.iterateFareOfBus(stopNumber);
  }



}
